import React from 'react'

/**
 * A cell naming one thing, in the manner of shadcn/ui's item: a 32px picture at the start, the name in
 * medium weight, and a line of detail under it in the smaller secondary text.
 */
const ItemCell: React.FC<{ media: React.ReactNode; title: React.ReactNode; description?: React.ReactNode }> = ({
  media,
  title,
  description
}) => (
  <span className="flex min-w-0 max-w-[300px] items-center gap-3 py-2">
    {media}
    <span className="flex min-w-0 flex-col gap-0.5">
      <span className="truncate font-medium leading-[18px]">{title}</span>
      {description && <span className="truncate text-[12px] leading-4 text-muted">{description}</span>}
    </span>
  </span>
)

/** A person's picture at the size of an item's icon tile. */
export const ItemAvatar: React.FC<{ src: string }> = ({ src }) => (
  <img className="size-8 shrink-0 rounded-full object-cover" src={src} alt="" />
)

export default ItemCell
